var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLedPlaceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#FFA700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.542V8.204c0-.343-.14-.672-.393-.91l-1.14-1.105a.667.667 0 00-.47-.189.682.682 0 00-.47.189l-1.134 1.098a1.275 1.275 0 00-.393.917v.755H7.333C6.6 8.96 6 9.54 6 10.251v6.458C6 17.419 6.6 18 7.333 18h9.334C17.4 18 18 17.419 18 16.709v-3.875c0-.71-.6-1.292-1.333-1.292H14zM8.667 16.71H7.333v-1.292h1.334v1.292zm0-2.584H7.333v-1.291h1.334v1.291zm0-2.583H7.333v-1.291h1.334v1.291zm4 5.167h-1.334v-1.292h1.334v1.292zm0-2.584h-1.334v-1.291h1.334v1.291zm0-2.583h-1.334v-1.291h1.334v1.291zm0-2.583h-1.334V7.668h1.334v1.291zm4 7.75h-1.334v-1.292h1.334v1.292zm0-2.584h-1.334v-1.291h1.334v1.291z",
    fill: "#fff"
  })));
}

export default SvgLedPlaceIcon;